export default __webpack_public_path__ + "static/media/coinbase_wallet.2debf3b2.svg";